import {
  CustomFormListFieldsFragment,
  CustomFormStatus,
  ExcelSpreadsheetTemplateFieldsFragment,
  HtmlDocumentTemplateFieldsFragment,
  WordDocumentTemplateFieldsFragment
} from '~/api/graphql';
import { TemplatePickerOption } from '~/components/cara-input/cara-input-template-picker-dialog';
import { htmlDocumentTemplateHasBody } from '~/components/workspaces/lib/html-document-artifact';

export const customFormPickerOptions = (
  forms: CustomFormListFieldsFragment[]
): TemplatePickerOption[] =>
  forms
    .filter((f) => f.status === CustomFormStatus.Ready && !f.archivedAt)
    .map((f) => ({ id: f.id, title: f.title }));

// Body-less records are export/preview styles, not templates.
export const htmlTemplatePickerOptions = (
  templates: HtmlDocumentTemplateFieldsFragment[]
): TemplatePickerOption[] =>
  templates.filter(htmlDocumentTemplateHasBody).map((t) => ({ id: t.id, title: t.title }));

export const wordTemplatePickerOptions = (
  templates: WordDocumentTemplateFieldsFragment[]
): TemplatePickerOption[] => templates.map((t) => ({ id: t.id, title: t.title }));

export const excelTemplatePickerOptions = (
  templates: ExcelSpreadsheetTemplateFieldsFragment[]
): TemplatePickerOption[] => templates.map((t) => ({ id: t.id, title: t.title }));
